import {Component, EventEmitter, Input, Output} from '@angular/core';
import {User} from "@pl/pl-lib/common";
import {CurrentIdentityProvider} from "@pl/authorisation-client";

@Component({
  selector: 'app-impersonation-user-select',
  templateUrl: './impersonation-user-select.component.html',
  styleUrls: ['./impersonation-user-select.component.scss']
})
export class ImpersonationUserSelectComponent {
  error: string | undefined;
  @Input()
  title: string;
  @Output()
  onCompleted = new EventEmitter<User>();
  excludedIds: string[] = [];
  public reason: string = '';

  constructor(
    private currentIdentityProvider: CurrentIdentityProvider,
  ) {
    this.excludedIds = [this.currentIdentityProvider.currentIdentityId!]
  }

  private _selectedUser: User;

  get selectedUser(): User {
    return this._selectedUser;
  }

  set selectedUser(value: User) {
    this._selectedUser = value;
    if (!value) {
      this.error = undefined;
      return;
    }
    this.currentIdentityProvider.canImpersonate(value.id).then(e => {
      if (e !== true) {
        this.error = e as string;
      } else {
        this.error = undefined;
      }
    })
  }

  public async onFinish() {
    if (this.selectedUser) {
      try {
        await this.currentIdentityProvider.impersonate(this.selectedUser.id, this.reason);
        this.onCompleted.emit(this.selectedUser);
      }catch (e){
        console.error(e);
        this.error = 'Error while starting impersonation. Please contact support.';
      }
    }else{
      this.onCompleted.emit(this.selectedUser);
    }

  }

  close() {
    this.onCompleted.emit(undefined);
  }
}
